import { Component, inject, resource, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NotificationService } from "@kno2/common/services/notifications";
import { APP_CONFIG_TOKEN } from "@kno2/core/config";
import { SessionService } from "@kno2/core/session";
import { EulasService } from "@kno2/data-access/eulas";
import { DialogBodyComponent, DialogFooterComponent, DialogService } from "@kno2/shared/dialog";

@Component({
    selector: "kno2-onboarding-terms-and-conditions-modal",
    imports: [FormsModule, DialogBodyComponent, DialogFooterComponent],
    templateUrl: "./onboarding-terms-and-conditions-modal.component.html"
})
export class OnboardingTermsAndConditionsModalComponent {
    private readonly dialogService = inject(DialogService);
    private readonly appConfig = inject(APP_CONFIG_TOKEN);
    private readonly eulasService = inject(EulasService);
    private readonly sessionService = inject(SessionService);
    private readonly notificationService = inject(NotificationService);

    protected readonly brandDisplayName = signal(this.appConfig.brandDisplayName);
    protected readonly hasBrandEula = signal(this.appConfig.hasBrandEula);
    protected readonly userProfile = signal(this.sessionService.profileData());
    protected readonly acceptedTermsAndConditions = signal(false);

    protected readonly eula = resource({
        loader: () => this.eulasService.getActive()
    });

    protected readonly eulaHtml = resource({
        loader: () => this.eulasService.getViewActive()
    });

    protected printTermsAndConditions(): void {
        const url = `policies/termsofuse?print=true`;
        window.open(url, "_blank");
    }

    protected async acceptTermsAndConditions(): Promise<void> {
        if (!this.acceptedTermsAndConditions()) return;

        const eulaData = this.eula.value();
        if (!eulaData?.id) {
            this.notificationService.error("The License Agreement could not be loaded. Please refresh the page and try again.");
            return;
        }

        try {
            await this.eulasService.accept(eulaData.id);
            this.sessionService.refreshProfile();
            this.dialogService.close(true);
        } catch {
            this.notificationService.error("An error occurred when accepting License Agreement.");
        }
    }
}
